import { render, staticRenderFns } from "./ProfileCompany.vue?vue&type=template&id=4a487adf&scoped=true&"
import script from "./ProfileCompany.vue?vue&type=script&lang=js&"
export * from "./ProfileCompany.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCompany.vue?vue&type=style&index=0&id=4a487adf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a487adf",
  null
  
)

export default component.exports